/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Form } from 'antd';

import { PatchUser } from '@/client';
import { QueryWrapper } from '@/components/QueryWrapper';
import { useUserByIdQuery } from '@/hooks/query/useUserByIdQuery';
import { UpdateUserForm } from '@/pages/UpdateUser/UpdateUserForm';
import { UpdateUserModal } from '@/pages/UpdateUser/UpdateUserModal';

export type UpdateUserPageProps = {
  userId: string;
};

export function UpdateUserPage({ userId }: UpdateUserPageProps) {
  const [form] = Form.useForm<PatchUser>();
  const userQuery = useUserByIdQuery({ userId });

  return (
    <UpdateUserModal form={form}>
      <QueryWrapper queryResult={userQuery}>
        {(userData) => <UpdateUserForm form={form} userData={userData} />}
      </QueryWrapper>
    </UpdateUserModal>
  );
}
